export default "__VITE_ASSET__CIkf$hRz__"